<template>
  <div class="box" v-html="agreementText"></div>
</template>

<script>
export default {
  name: "PartnerAgreementPage",
  data() {
    return {
      agreementText: "",
    };
  },
  async created() {
    const res = await this.$apis.zzsignServe.ZwSignServeAgreement();
    if (res.resultCode === "200") {
      this.agreementText = res.content.detail[0].content;
    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 20px;
}
</style>
